module.exports = __webpack_public_path__ + "static/media/logo-stg2.54367c9b.svg";